import { useState } from "react";

const LINK = "https://tallyeducation.com/campaign/?p=MP-302";

const EnquiryLinkInfo = () => {
  const [copied, setCopied] = useState(false);

  const copyLink = () => {
    navigator.clipboard.writeText(LINK);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const emailLink = () => {
    window.location.href = `mailto:?subject=Enquiry Link&body=${encodeURIComponent(LINK)}`;
  };

  return (
    <div className="px-1">
      <div className="d-flex align-items-center justify-content-between mb-3 pb-2" style={{ borderBottom: "2px solid #4d3d6c" }}>
        <h6 className="fw-bold mb-0" style={{ color: "#4d3d6c" }}>
          <i className="bi bi-link-45deg me-2"></i>Enquiry Link
        </h6>
      </div>

      <div className="card shadow-sm mb-4" style={{ maxWidth: "600px" }}>
        <div className="card-body">
          <label className="form-label fw-semibold" style={{ fontSize: "13px" }}>Your Enquiry Link</label>
          <div className="input-group">
            <input type="text" className="form-control" readOnly value={LINK} style={{ fontSize: "13px" }} />
            <button className="btn btn-success" onClick={copyLink}>
              <i className={`bi ${copied ? 'bi-check-lg' : 'bi-clipboard'} me-1`}></i>
              {copied ? "Copied!" : "Copy"}
            </button>
            <button className="btn btn-outline-success" onClick={emailLink}>
              <i className="bi bi-envelope me-1"></i>Email
            </button>
          </div>
        </div>
      </div>

      <div className="card shadow-sm" style={{ maxWidth: "600px" }}>
        <div className="card-header fw-bold py-2 px-3" style={{ background: "#f0ebff", color: "#4d3d6c", fontSize: "13px" }}>
          <i className="bi bi-info-circle me-2"></i>How to use the Enquiry Link
        </div>
        <div className="card-body" style={{ fontSize: "13px" }}>
          <ol className="mb-0" style={{ lineHeight: "2" }}>
            <li>Click <strong>Copy</strong> and share via social media, or click <strong>Email</strong> to send via email.</li>
            <li>Once a student submits the form, their details appear as a lead in <strong>Student Leads → Lead List</strong>.</li>
            <li>To view details, select <strong>Filters → Source → Enquiry Link</strong> and click Show.</li>
            <li>To enroll a lead, click the settings icon under Action and select <strong>Enroll Student</strong>.</li>
            <li>Select the Certificate/Combo and fill the Program Date — rest will be auto-filled.</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default EnquiryLinkInfo;
